import React from "react";
import { CardsGrid } from "./__styles__/MapObjects";
import CustomMapCard from "./CustomMapCard";
import { CustomMapForSettings } from "./types";

interface MapObjectsGridProps {
  customMaps: Array<CustomMapForSettings>;
  showEditModal: (map: CustomMapForSettings) => void;
  showDeleteModal: (map: CustomMapForSettings) => void;
  isObject: boolean;
}

const MapObjectsGrid = ({
  customMaps,
  showEditModal,
  showDeleteModal,
  isObject,
}: MapObjectsGridProps) => {
  if (customMaps.length === 0) {
    return <div>{isObject ? "No map objects" : "No custom maps"}</div>;
  }

  return (
    <CardsGrid>
      {customMaps.map(customMap => (
        <CustomMapCard
          key={customMap.id}
          customMap={customMap}
          actions={[
            { label: "Edit", onClick: () => showEditModal(customMap) },
            {
              label: "Delete",
              variant: "red",
              onClick: () => showDeleteModal(customMap),
            },
          ]}
        />
      ))}
    </CardsGrid>
  );
};

export default MapObjectsGrid;
